export const STORE_PRODUCTS_SAGA = "STORE_PRODUCTS_SAGA";
export const STORE_PRODUCTS = "STORE_PRODUCTS";

export const STORE_PAGINATION_SAGA = "STORE_PAGINATION_SAGA";
export const STORE_PAGINATION = "STORE_PAGINATION";

export const STORE_AUTHDATA_SAGA = "STORE_AUTHDATA_SAGA";
export const STORE_AUTHDATA = "STORE_AUTHDATA";

export const LOGOUT_SAGA = "LOGOUT_SAGA";
export const LOGOUT = "LOGOUT";
